import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'
import { KeysAndLabels } from '~/prix/types/enumerated'

export const select = (shape: z.ZodObject<any>) =>
  z
    .array(
      enumerated(
        Object.keys(shape.shape).reduce((acc, key) => {
          acc[key] = shape.shape[key].description
          return acc
        }, {} as KeysAndLabels<string>),
      ),
    )
    .optional()
